module.exports = __webpack_public_path__ + "img/2024112904.678ca44a.png";